import axios from "axios"

const submitToMailChimp = async (enabled = false, name = "", email = "") => {
  if (!enabled || !name || !email) return true

  await axios.post("/api/submit-to-mailchimp", { name, email })

  return true
}

export default submitToMailChimp
